export const NRV_GOAL_MIN = 0;
export const NRV_GOAL_MAX = 100000;
